import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { BillingService } from '../../../services/billing/billing.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from '../../../services/campaigns/campaign.service';
import Swal from 'sweetalert2';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { User } from '../../../core/models/user';
import { getFirebaseBackend } from 'src/app/authUtils';
import { UserService } from 'src/app/services/user/user.service';
import { AuthorizePaymentService } from 'src/app/services/payment/payment.service';
import { BillComService } from 'src/app/services/payment/billcom.service';

// t3client001 authorize id 680418465
@Component({
	selector: 'app-not-payed-leads',
	templateUrl: './not-payed-leads.component.html',
	styleUrls: ['./not-payed-leads.component.scss'],
})
export class NotPayedLeadsComponent implements OnInit {
	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild('chargingModal') chargingModal: TemplateRef<any>;
	@ViewChild('modalCustomerId') modalCustomerId: TemplateRef<any>;
	@Input() payment_provider: any;
	@Output() newCard = new EventEmitter<any>();
	@Output() setAch = new EventEmitter<any>();

	notPayedLeads: any[];
	leads: any[];
	loading: boolean;
	columnMode = ColumnMode;
	selectedLead: any;
	prices: any[];
	selectedCost: string;
	loadingPrices: boolean;
	loadingCharge = false;
	user: User = null;
	gettedCustomerNMI: any = {
		customerId: '',
		first_name: '',
		last_name: '',
		address_1: '',
		address_2: '',
		company: '',
		city: '',
		state: '',
		postal_code: '',
		country: '',
		email: '',
		phone: '',
		cc_number: '',
	};
	cardToPay = '';
	loadingCard = false;
	copied = false;

	// Search NGX Datatable
	temp = [];
	columns: any[];

	showInactiveCampaigns = false;

	isAchCharge = false;

	constructor(private billingSrv: BillingService, public authorizeSrv: AuthorizePaymentService, private modalService: NgbModal, private campaignSrv: CampaignService, private userSrv: UserService, private dataService: OldDataService, private cdr: ChangeDetectorRef, private billcomSrv: BillComService) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.columns = [
			{
				name: 'Agent',
				prop: 'agent_name',
				showed: false,
			},
			{
				name: 'Alias',
				prop: 'alias',
				showed: true,
			},
			{
				name: 'Prospect',
				prop: 'prospect_company',
				showed: true,
			},
			{
				name: 'Reserve',
				prop: 'isReserve',
				showed: true,
			},
		];
	}

	ngOnInit(): void {
		this.getNotPayedLeads();
	}

	getNotPayedLeads() {
		this.loading = true;
		this.billingSrv.getNotPayedLeads().subscribe((data: any) => {
			this.leads = data.body;
			this.hideInactiveCampaignsLeads();
			this.loading = false;
			this.cdr.detectChanges();
		});
	}

	getCellClassCampaign({ row, column, value }): any {
		return {
			' back-cell-gray content-point': row['id'] > 0,
		};
	}

	getCellClassOptions({ row, column, value }): any {
		return {
			' cellForButtons back-cell-text-right': row['id'] > 0,
		};
	}

	warningCharge(lead: any) {
		this.selectedLead = lead;
		this.copied = false;

		if (this.payment_provider === 'NMI') {
			if (this.selectedLead.cus_id != '') {
				this.getPrices();
				this.openModalSelectAmount();
			} else {
				this.openModalSelectNMICustomer();
			}
		} else {
			// AUTHORIZE
			this.getPrices();
			this.openModalSelectAmountAuthorize();
		}
	}

	openModalSelectNMICustomer() {
		this.loadingPrices = true;
		this.billingSrv.getCusIdFromNMI(this.selectedLead.email).subscribe((data: any) => {
			if (data.body !== 'Customer not found') {
				this.gettedCustomerNMI = data.body;
			}
			this.loadingPrices = false;
		});

		this.modalService.open(this.modalCustomerId, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info('Cerrado en result');
			},
			(reason) => {
				console.info('Cerrado en reason');
			}
		);
	}

	openModalSelectCustomerId() {
		this.modalService.open(this.modalCustomerId, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info('Cerrado en result');
			},
			(reason) => {
				console.info('Cerrado en reason');
			}
		);
	}

	openModalSelectAmount() {
		this.loadingCard = true;
		this.billingSrv.getDefaultPaymentMethod(this.selectedLead.cus_id).subscribe((data: any) => {
			this.cardToPay = data.body;
			this.loadingCard = false;
		});
		this.modalService.open(this.chargingModal, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info('Cerrado en result');
			},
			(reason) => {
				this.selectedCost = '';
				this.loadingCharge = false;
			}
		);
	}

	getPrices() {
		this.loadingPrices = true;
		this.campaignSrv.getCampaignPrices(this.selectedLead.campaign_id).subscribe((data: any) => {
			this.prices = data.body;
			this.loadingPrices = false;
			const leadCost = this.prices.find((price) => price.description === 'Lead Cost');
			this.selectedCost = `${leadCost.description} - ${leadCost.price}`;
		});
	}

	chargeOfficial() {
		this.loadingCharge = true;
		this.userSrv.getUserByAlias(this.selectedLead.alias).subscribe((data: any) => {
			let user = data.body;
			let credito = 'F';
			this.selectedLead.lead_cost = this.selectedCost.split(' - ')[1];

			if (user.credit > 0) {
				credito = 'T';
				this.selectedLead.lead_cost = (parseFloat(this.selectedLead.lead_cost) - 1.0).toString();
			}
			if (user.cus_id != '' && user.cus_id != undefined && user.cus_id != null) {
				Swal.fire({
					title: 'Charging',
					text: 'We are Charging the lead',
					confirmButtonText: 'Ok',
					didOpen: () => {
						this.modalService.dismissAll();
						Swal.showLoading();
						const payload = {
							cvv: '',
							cus_id: user.cus_id,
							amount: this.selectedLead.lead_cost,
							lead_id: this.selectedLead.lead_id,
							credit: credito,
							appt_date: this.selectedLead.date_generated,
							user_id: user.id,
							prospect_company: this.selectedLead.prospect_company,
						};

						this.billingSrv.chargeLead(payload).subscribe((data: any) => {
							if (data.body === 'Need CVV') {
								Swal.close();
								this.askCvv().then((result) => {
									Swal.fire({
										title: 'Charging',
										text: 'We are Charging the lead',
										confirmButtonText: 'Ok',
										didOpen: () => {
											Swal.showLoading();
											const payload2 = {
												cvv: result.value,
												cus_id: user.cus_id,
												amount: this.selectedLead.lead_cost,
												lead_id: this.selectedLead.lead_id,
												credit: credito,
												appt_date: this.selectedLead.date_generated,
												user_id: user.id,
												prospect_company: this.selectedLead.prospect_company,
											};

											this.billingSrv.chargeLead(payload2).subscribe((data: any) => {
												this.successTransaction();
											});
										},
									});
								});
							} else {
								Swal.close();
								if (data.error) {
									this.errorTransaction(data.error);
								} else {
									this.successTransaction();
								}
							}
						});
					},
				});
			} else {
				this.collectCheckout();
			}
		});
	}

	async askCvv() {
		let resultado: any;
		await Swal.fire({
			title: 'CVV Required',
			text: 'This user is already on our customer list, but we need the CVV for the first charge',
			input: 'text',
			inputAttributes: {
				autocapitalize: 'off',
			},
			showCancelButton: true,
			confirmButtonText: 'Charge',
		}).then((result) => {
			resultado = result;
		});

		return resultado;
	}

	collectCheckout() {
		// TEST const url = 'https://collectcheckout.com/r/uyw3k';
		const url = 'https://collectcheckout.com/r/gvy03';
		Swal.fire({
			title: 'Use this email on pop up',
			text: this.selectedLead.email,
			allowOutsideClick: false,
			allowEscapeKey: false,
			allowEnterKey: false,
		}).then(() => {
			this.modalService.dismissAll();
			this.getNotPayedLeads();
		});
		window.open(url, '_blank', 'location=no,height=700,width=500,scrollbars=yes,status=yes,left=390');
	}

	successTransaction() {
		Swal.fire({
			title: 'Success',
			text: 'Success Transaction',
			showCancelButton: false,
			confirmButtonText: 'ok',
		}).then((result) => {
			this.getNotPayedLeads();
		});
	}

	errorTransaction(error: string) {
		Swal.fire({
			title: 'Error',
			text: error,
			showCancelButton: false,
			confirmButtonText: 'ok',
		});
	}

	freeLeadModal(content, lead) {
		this.selectedLead = lead;
		this.modalService
			.open(content, {
				ariaLabelledBy: 'modal-basic-title',
				centered: true,
			})
			.result.then(
				(result) => {
					//this.closeResult = `Closed with: ${result}`;
				},
				(reason) => {
					// this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
				}
			);
	}

	// setFreeLead(free_type) {
	// 	const payload = {
	// 		leadId: this.selectedLead.lead_id,
	// 		employee: this.user.Login,
	// 		free_type: free_type,
	// 		prospect_company: this.selectedLead.prospect_company,
	// 		appt_date: this.selectedLead.date_generated,
	// 	};
	// 	Swal.fire({
	// 		title: 'Set as Free',
	// 		text: '',
	// 		confirmButtonText: 'Ok',
	// 		didOpen: () => {
	// 			Swal.showLoading();
	// 			this.billingSrv.setAsFree(payload).subscribe((data: any) => {
	// 				this.getNotPayedLeads();
	// 				this.modalService.dismissAll();
	// 				Swal.fire({
	// 					title: 'Success',
	// 					text: 'The lead was charged successfuly',
	// 					showCancelButton: false,
	// 					confirmButtonText: 'Ok',
	// 					cancelButtonText: 'Cancel',
	// 				});
	// 			});
	// 		},
	// 	});
	// }

		setFreeLead(free_type) {
		const payload = {
			leadId: this.selectedLead.lead_id,
			employee: this.user.Login,
			free_type: free_type,
			prospect_company: this.selectedLead.prospect_company,
			appt_date: this.selectedLead.date_generated,
			user_id: (this.user as any).IdUser,
		};
		Swal.fire({
			title: 'Set as Free',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.billingSrv.setAsFree(payload).subscribe({
					next: (data: any) => {
						this.getNotPayedLeads();
						this.modalService.dismissAll();
						Swal.fire({
							title: 'Success',
							text: 'The lead was charged successfuly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
					},
										error: (err) => {
						const message = typeof err === 'string' ? err : err?.error?.message || '';

						if (message.includes('Insufficient reserve balance')) {
							Swal.fire({
								title: 'Insufficient reserve balance',
								icon: 'warning',
								html: `This campaign doesn't have enough reserve funds to release this lead.<br><br><strong>${message.replace('Insufficient reserve balance. ', '')}</strong><br><br>Add a deposit from <strong>Campaigns → Action → Reserve</strong> and try again.`,
								confirmButtonText: 'Ok',
							});
						} else {
							Swal.fire({
								title: 'Error',
								icon: 'error',
								text: message || 'The lead could not be set as free.',
								confirmButtonText: 'Ok',
							});
						}
					},
				});
			},
		});
	}

	searchNgxDatatable(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		// filter our data

		const temp = this.temp.filter(function (d) {
			// Verifica si alguna de las propiedades contiene el valor buscado
			return propArray.some((prop) => {
				return d[prop].toString().toLowerCase().indexOf(val) !== -1 || !val;
			});
		});

		// update the rows
		this.notPayedLeads = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	showHideColumns(columnProp) {
		const obj = this.columns.find((column) => {
			return column.prop === columnProp;
		});
		return obj.showed;
	}

	toogleShowInactiveCampaigns() {
		if (this.showInactiveCampaigns) {
			this.hideInactiveCampaignsLeads();
			this.showInactiveCampaigns = false;
		} else {
			this.showInactiveCampaigns = true;
			this.showInactiveCampaignsLeads();
		}
	}

	hideInactiveCampaignsLeads() {
		this.notPayedLeads = this.leads.filter((lead) => {
			return lead.campaign_active == 1;
		});
		this.temp = [...this.notPayedLeads];
	}

	showInactiveCampaignsLeads() {
		this.notPayedLeads = this.leads;
		this.temp = [...this.notPayedLeads];
	}

	linkCustomer() {
		this.loadingPrices = true;
		this.billingSrv.linkNmiCustomer(this.gettedCustomerNMI.email, this.gettedCustomerNMI.customerId).subscribe((data: any) => {
			this.getNotPayedLeads();
			setTimeout(() => {
				this.loadingPrices = false;
				if (data.body === 'success') {
					Swal.fire({
						title: 'Success',
						text: 'Customer linked successfully',
						showCancelButton: false,
						confirmButtonText: 'ok',
						allowOutsideClick: false,
						allowEscapeKey: false,
						allowEnterKey: false,
					}).then((result) => {
						this.modalService.dismissAll();
						const lead = this.notPayedLeads.find((lead) => lead.id === this.selectedLead.id);
						this.warningCharge(lead);
					});
				}
			}, 1000);
		});
	}

	addNewCard(content: TemplateRef<any>) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info('Cerrado en result');
			},
			(reason) => {
				console.info('Cerrado en reason');
			}
		);
	}

	submitCardForm(cardForm: any) {
		if (cardForm.valid) {
			const formData = {
				cardNumber: cardForm.value.cardNumber,
				first_name: cardForm.value.first_name,
				last_name: cardForm.value.last_name,
				expiryDate: cardForm.value.expiryDate,
				billingAddress: cardForm.value.billingAddress,
				postalCode: cardForm.value.postalCode,
				cus_id: this.selectedLead.cus_id,
			};

			this.loadingCard = true;
			this.billingSrv.addNewCard(formData).subscribe((response: any) => {
				// 	this.loadingCard = false;
				// 	if (response.success) {
				// 		Swal.fire({
				// 			title: 'Success',
				// 			text: 'Card added successfully',
				// 			icon: 'success',
				// 			confirmButtonText: 'Ok'
				// 		}).then(() => {
				// 			this.modalService.dismissAll();
				// 		});
				// 	} else {
				// 		Swal.fire({
				// 			title: 'Error',
				// 			text: response.message,
				// 			icon: 'error',
				// 			confirmButtonText: 'Ok'
				// 		});
				// 	}
				// },
				// (error: any) => {
				// 	this.loadingCard = false;
				// 	Swal.fire({
				// 		title: 'Error',
				// 		text: 'An error occurred while adding the card',
				// 		icon: 'error',
				// 		confirmButtonText: 'Ok'
				// 	});
				// }
			});
		}
	}

	copyToClipboard() {
		const el = document.createElement('textarea');
		el.value = `${this.selectedLead.cus_id}`;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
		this.copied = true;
	}

	setPayedLead() {
		let selectedUser: any;

		Swal.fire({
			title: 'Sending Email',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.userSrv.getUserByAlias(this.selectedLead.alias).subscribe((data: any) => {
					selectedUser = data.body;
					const payload = {
						user_id: selectedUser.id,
						leadId: this.selectedLead.lead_id,
						normal_amount: this.selectedLead.lead_cost,
						paidBy: this.selectedLead.alias,
						employee: this.user.Login,
						prospect_company: this.selectedLead.prospect_company,
						appt_date: this.selectedLead.date_generated,
					};
					this.billingSrv.setAsPayed(payload).subscribe((data: any) => {
						this.modalService.dismissAll();
						Swal.close();
						Swal.fire({
							title: 'Success',
							text: 'The lead was charged successfuly',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel',
						});
						this.getNotPayedLeads();
					});
				});
			},
		});
	}

	// Authorize functions FLOW

	openModalSelectAmountAuthorize() {
		this.modalService.open(this.chargingModal, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(
			(result) => {
				console.info('Cerrado en result');
			},
			(reason) => {
				this.selectedCost = '';
				this.loadingCharge = false;
				this.isAchCharge = false;
			}
		);
	}

	chargeAuthorizeNet(chase: boolean = false) {

		this.loadingCharge = true;
		this.selectedLead.lead_cost = this.selectedCost.split(' - ')[1];

		const payload = {
			profileId: this.selectedLead.authorize_id,
			payment_id: this.selectedLead.payment_id,
			amount: this.selectedLead.lead_cost,
			leadId: this.selectedLead.lead_id,
			appt_date: this.selectedLead.date_generated,
			prospect_company: this.selectedLead.prospect_company,
			chase: false
		};

		if(chase) {
			payload.profileId = this.selectedLead.chase_authorize_id;
			payload.payment_id = this.selectedLead.chase_payment_id;
			payload.chase = true;
		}

		Swal.fire({
			title: 'Charging',
			text: 'We are Charging the lead',
			confirmButtonText: 'Ok',
			didOpen: () => {
				this.modalService.dismissAll();
				Swal.showLoading();
				this.authorizeSrv.charge_customer(payload).subscribe(
					(data: any) => {
						this.loadingCharge = false;
						if (data.success) {
							this.getNotPayedLeads();
							Swal.close();

							if (data.body.message == 'Already paid') {
								Swal.fire({
									title: `Validate`,
									icon: 'warning',
									text: `Lead ${this.selectedLead.lead_id} was already charged with transaction id ${data.body.transaction_id}. Please validate it at authorize.net`,
									showCancelButton: false,
									confirmButtonText: 'Ok',
								});
							} else {
								Swal.fire({
									title: `Success`,
									icon: 'success',
									text: `Lead ${this.selectedLead.lead_id} was charged successfuly`,
									showCancelButton: false,
									confirmButtonText: 'Ok',
								});
							}
						} else {
							Swal.fire({
								title: `Error`,
								icon: 'error',
								text: `There was an error on charge Lead ${this.selectedLead.lead_id}`,
								showCancelButton: false,
								confirmButtonText: 'Ok',
							}).then((data) => {
								this.getNotPayedLeads();
							});
						}
					},
					(error) => {
						console.error(error);
					}
				);
			},
		});
	}

	setAuthorizeCard(lead: any) {
		this.selectedLead = lead;
		this.newCard.emit(this.selectedLead);
	}

	setAchProfile(lead: any) {
		this.selectedLead = lead;
		this.setAch.emit(lead);
	}

	chargeAchLead(lead: any) {
		this.selectedLead = lead;
		this.isAchCharge = true;
		this.getPrices();
		this.openModalSelectAmountAuthorize();
	}

	chargeAch() {
		this.loadingCharge = true;
		this.selectedLead.lead_cost = this.selectedCost.split(' - ')[1];

		const payload = {
			leadId: this.selectedLead.lead_id,
			userId: this.selectedLead.user_id,
			amount: this.selectedLead.lead_cost,
			appt_date: this.selectedLead.date_generated,
			prospect_company: this.selectedLead.prospect_company,
		};

		Swal.fire({
			title: 'Charging ACH',
			text: 'Processing ACH payment via Bill.com',
			confirmButtonText: 'Ok',
			didOpen: () => {
				this.modalService.dismissAll();
				Swal.showLoading();
				this.billcomSrv.charge_ach(payload).subscribe(
					(data: any) => {
						this.loadingCharge = false;
						this.isAchCharge = false;
						if (data.success) {
							this.getNotPayedLeads();
							Swal.close();
							Swal.fire({
								title: 'Success',
								icon: 'success',
								text: `Lead ${this.selectedLead.lead_id} was charged successfully via ACH`,
								confirmButtonText: 'Ok',
							});
						} else {
							Swal.fire({
								title: 'Error',
								icon: 'error',
								text: `Error charging Lead ${this.selectedLead.lead_id} via ACH`,
								confirmButtonText: 'Ok',
							}).then(() => this.getNotPayedLeads());
						}
					},
					(error) => {
						this.loadingCharge = false;
						this.isAchCharge = false;
						console.error(error);
					}
				);
			},
		});
	}
}
